module.exports = __webpack_public_path__ + "static/privacy_policy-f707762787d0c49def4406b02f2ac7d2.pdf";